module.exports = __webpack_public_path__ + "img/806b3c4.png";